const ServiceProviderNameType = Symbol();

// 事業者名の最大長
export const ServiceProviderNameMaxLength = 200;

export class ServiceProviderName {
    [ServiceProviderNameType]: any;
    readonly value: string;

    private constructor(name: string) {
        this.value = name;
    }

    static fromString(name: string): ServiceProviderName {
        return new ServiceProviderName(name);
    }

    static fromNothing(): ServiceProviderName {
        return new ServiceProviderName("");
    }

    // 事業者名の長さチェック
    isValidLength(): boolean {
        return !!this.value.length && !(this.value.length > ServiceProviderNameMaxLength);
    }
}
